export type chatType = 'AGENT' | 'ASK_MY_DOCS' | 'ASK_GENE'
export type ChatMetaData = {
  title: string;
  id: string;
  agentId?: string;
  updatedAt: Date;
  created: Date;
  type?: chatType;
}

export function buildRoute(chat: ChatMetaData) {
  return chat.agentId ? `/agents/${chat.agentId}/chat/${chat.id}` : `/chat/${chat.id}`;
}
